import L from 'leaflet';

const PULSE_MARKER_STYLE_ID = 'driver-gps-pulse-marker-styles';
const MARKER_BLUE = '#2563eb';
const MARKER_BLUE_GLOW = 'rgba(37, 99, 235, 0.95)';
const MARKER_BLUE_GLOW_SOFT = 'rgba(37, 99, 235, 0.45)';
const MARKER_BLUE_BORDER = '#1d4ed8';

const pulseMarkerStyles = `
  .driver-gps-pulse-marker {
    background: transparent !important;
    border: none !important;
  }
  .driver-gps-pulse-marker__wrapper {
    position: relative;
    width: 68px;
    height: 68px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .driver-gps-pulse-marker__glow {
    position: absolute;
    width: 58px;
    height: 58px;
    border-radius: 9999px;
    background: radial-gradient(circle, ${MARKER_BLUE_GLOW} 0%, ${MARKER_BLUE_GLOW_SOFT} 45%, rgba(37, 99, 235, 0) 72%);
    filter: blur(3px);
  }
  .driver-gps-pulse-marker__badge-ring {
    position: absolute;
    border-radius: 9999px;
    border: 1.5px solid ${MARKER_BLUE};
    box-shadow: 0 0 8px 1px ${MARKER_BLUE_GLOW};
    opacity: 0.9;
  }
  .driver-gps-pulse-marker__badge-ring--outer {
    width: 40px;
    height: 40px;
  }
  .driver-gps-pulse-marker__badge-ring--inner {
    width: 32px;
    height: 32px;
  }
  .driver-gps-pulse-marker__ring {
    position: absolute;
    width: 30px;
    height: 30px;
    border-radius: 9999px;
    background: transparent;
    border: 3px solid ${MARKER_BLUE};
    box-shadow: 0 0 12px 2px ${MARKER_BLUE_GLOW};
    opacity: 1;
    animation: driver-gps-pulse-ring 1.8s cubic-bezier(0.15, 0.7, 0.3, 1) infinite;
  }
  .driver-gps-pulse-marker__ring--delayed {
    animation-delay: 0.9s;
  }
  .driver-gps-pulse-marker__core {
    position: relative;
    width: 24px;
    height: 24px;
    border-radius: 9999px;
    background: ${MARKER_BLUE};
    border: 3px solid ${MARKER_BLUE_BORDER};
    box-shadow:
      0 0 8px 2px ${MARKER_BLUE_GLOW},
      0 0 18px 4px ${MARKER_BLUE_GLOW_SOFT},
      0 0 32px 6px rgba(29, 78, 216, 0.4),
      0 2px 6px rgba(15, 23, 42, 0.4);
    animation: driver-gps-pulse-core 1.8s ease-in-out infinite;
  }
  @keyframes driver-gps-pulse-ring {
    0% {
      transform: scale(0.4);
      opacity: 1;
    }
    65% {
      opacity: 0.4;
    }
    100% {
      transform: scale(3.2);
      opacity: 0;
    }
  }
  @keyframes driver-gps-pulse-core {
    0%,
    100% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.18);
    }
  }
`;

function ensurePulseMarkerStylesInjected(): void {
  if (typeof document === 'undefined') return;

  const existingStyle = document.getElementById(PULSE_MARKER_STYLE_ID);
  if (existingStyle) {
    existingStyle.textContent = pulseMarkerStyles;
    return;
  }

  const style = document.createElement('style');
  style.id = PULSE_MARKER_STYLE_ID;
  style.textContent = pulseMarkerStyles;
  document.head.appendChild(style);
}

export const createGpsPulseMarkerIcon = (): L.DivIcon => {
  ensurePulseMarkerStylesInjected();

  return L.divIcon({
    className: 'driver-gps-pulse-marker',
    html: `
      <div class="driver-gps-pulse-marker__wrapper">
        <div class="driver-gps-pulse-marker__glow"></div>
        <div class="driver-gps-pulse-marker__badge-ring driver-gps-pulse-marker__badge-ring--outer"></div>
        <div class="driver-gps-pulse-marker__badge-ring driver-gps-pulse-marker__badge-ring--inner"></div>
        <div class="driver-gps-pulse-marker__ring"></div>
        <div class="driver-gps-pulse-marker__ring driver-gps-pulse-marker__ring--delayed"></div>
        <div class="driver-gps-pulse-marker__core"></div>
      </div>
    `,
    iconSize: [68, 68],
    iconAnchor: [34, 34],
  });
};
